import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import * as _ from 'lodash';

import { VersionsService } from '@core/services/versions/versions.service';
import { UrlService } from '@core/services/url/url.service';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { VersionListItemMenuClick } from '../list/version-list-item-menu-click';

import * as  Objects from '@core/objects';
import { VersionFeedback } from '@core/models/version-feedback';

// import { Approval } from '@core/objects/approval';

import {    VersionShare, 
            UploadVersionStatusColorValues, 
            FeedbackStatusColorValues,
            ApprovalStatusColorValues,
            VersionShareType } from '@core/models/version-share.model';

@Component({
    selector: 'core-versions-summary-box',
    templateUrl: './summary-box.component.html',
    styleUrls: ['./summary-box.component.scss']
})
export class VersionsSummaryBoxComponent implements OnInit {
    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;

    public readonly APPROVAL_STATUS_COLORS = ApprovalStatusColorValues; //['#F6B273','#47B934','#F44848'];
    public readonly FEEDBACK_STATUS_COLORS = FeedbackStatusColorValues;
    public readonly UPLOAD_VERSION_STATUS_COLORS = UploadVersionStatusColorValues;

        //0-> Pending: F0BC36 (old'#F6B273',)
        //1-> Approved: 47B934 (old'#92D77D',)
        //2-> Rejected: F44848   (old'#C8494E', )
        //3-> only comments: '#C8494E', ????

    @Input() version: Objects.Version;
    @Input() uploaded: boolean = false;
    @Input() feedbacks: Array<VersionFeedback>;
    @Input() exclude: Array<Objects.Label> = [];
    @Input() menu: Array<ThreeDotsMenuItem> = [];
    @Input() filesPrefixUrl: string = "";
    @Input() listItemModeOnly: boolean = false;
    // updated dec-2023 <diego@twonas.com>
    @Input() versionShares: Array<VersionShare> = [];

    @Output() menuClick = new EventEmitter<VersionListItemMenuClick>();
    @Output() actionFileClick = new EventEmitter<Objects.File>();
    @Output() actionLabelClick = new EventEmitter<Objects.Label>();
    


    public status: number = this.STATUS_LOADING;
    public opened: boolean = false;
    public files: Array<Objects.File> = [];
    public diffLabels: Array<Objects.Label> = [];
    public feedbacksList: Array<VersionFeedback>;
    protected areLabelsObserved: boolean = false;
    // updated dec-2023 <diego@twonas.com>
    public bubblesList: Array<VersionShare>;

    
    constructor(private versionSrv: VersionsService, private urlSrv: UrlService, private cdr:ChangeDetectorRef ) { }

    ngOnInit() {
        // check if there are observer on the Output.
        this.areLabelsObserved = this.actionLabelClick.observed;
        if(this.version != null)
            this.updateDiffLabels();
        
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes.feedbacks) {
            // get only unique feedback by each user when not null
            this.feedbacksList = this.feedbacks!= null ? Array.from(new Set(this.feedbacks.map(a => a.user.id)))
                .map(id => {
                    return this.feedbacks.find(a => a.user.id === id)
                }) : this.feedbacks;
        }
        // updated dec-2023 <diego@twonas.com>
        if(changes.versionShares) {
            // // get only unique versionShares by each entry user when not null (not anymore)
            // this.bubblesList = this.versionShares!= null ? Array.from(new Set(this.versionShares.map((vs: VersionShare) => vs.entry.user.id)))
            //     .map((idUser: string) => {
            //         return this.versionShares.find((vsi: VersionShare) => vsi.entry.user.id === idUser)
            //     }) : this.versionShares;
            // show all shares included for same user
            this.bubblesList = this.versionShares;
        }

        if(changes.exclude){
            this.updateDiffLabels();

        }
    }

    toogleFiles(event: any) {
        if(this.listItemModeOnly) //avoid open the files
            return;
        this.opened = !this.opened;
        // event.stopPropagation();

        if(this.status == this.STATUS_DONE)
            return;

        this.versionSrv.getFiles$(this.version, this.filesPrefixUrl).subscribe((files: Array<Objects.File>) => {
            // console.debug(" LOAD FILES VERSION files",files)
            this.files = files;
            this.status = this.STATUS_DONE;
            this.cdr.detectChanges();
        })

    }


    onMenuSelect(key: string) {
        this.menuClick.emit({key: key, version: this.version});
    }

    onLabelSelect(tag: Objects.Label) {
        this.actionLabelClick.emit(tag);
    }

    // download file directly
    onActionDownloadClick(file: Objects.File){
        window.location.href = this.urlSrv.build('/files/'+file.id);
    }

    // public getApprovalColor(approval: Approval){
    //     if (approval != null)
    //         return this.APPROVAL_STATUS_COLORS[approval.status_code];
    //     return this.FEEDBACK_ONLY_COMMENT_COLOR;
    // }

    public getBubbleColor(feedback: VersionFeedback){
        if (feedback.approval != null){
            return this.APPROVAL_STATUS_COLORS[feedback.approval.status_code];
        } else {
            return this.FEEDBACK_STATUS_COLORS[feedback.status.status_code];
        }
    }

    // updated dec-2023 and ready to get all kind shares bubbles <diego@twonas.com>
    public getShareBubbleColor(share: VersionShare) {
        switch (share.type) {
            case VersionShareType.UPLOAD_VERSION_TYPE:
                return this.UPLOAD_VERSION_STATUS_COLORS[share.status.status_code];
                break;
            case VersionShareType.FEEDBACK_TYPE:
                return this.FEEDBACK_STATUS_COLORS[share.status.status_code];
                break;
            case VersionShareType.APPROVAL_TYPE:
                return this.APPROVAL_STATUS_COLORS[share.status.status_code];
                break;
            default:
                return  this.FEEDBACK_STATUS_COLORS[0];
                break;
        }
    }

    private updateDiffLabels() {
        this.diffLabels = this.version.labels.filter((label: Objects.Label) => !this.exclude.some((l) => l.id == label.id));
    }

}
